import { useCallback, useState } from "react";
import { buildBusinessSetupEntityBreadcrumbs } from "Helpers/businessSetupEntityBreadcrumbs";
import type { BreadcrumbItem } from "Helpers/generalBreadcrumbs";

type Action = "create" | "edit" | "view" | "details";

/**
 * Keeps a saved entity label for breadcrumbs (not live form value).
 * Call `captureLabel` after load and after successful update.
 */
export function useBusinessSetupEntityBreadcrumbs(args: {
  /** Defaults to "businessSetup"; use "general" for General sidebar modules */
  sectionLabelKey?: string;
  moduleLabelKey: string;
  moduleHref: string;
  entityFallbackLabelKey?: string;
  isEdit: boolean;
  action?: Action;
  createAction?: Action;
}) {
  const [savedLabel, setSavedLabel] = useState("");

  const breadcrumbItems: BreadcrumbItem[] = buildBusinessSetupEntityBreadcrumbs({
    sectionLabelKey: args.sectionLabelKey || "businessSetup",
    moduleLabelKey: args.moduleLabelKey,
    moduleHref: args.moduleHref,
    entityLabel: savedLabel,
    entityFallbackLabelKey: args.entityFallbackLabelKey,
    action: args.isEdit
      ? args.action || "edit"
      : args.createAction || "create",
  });

  const captureLabel = useCallback((label?: string | null) => {
    setSavedLabel((label || "").trim());
  }, []);

  return { breadcrumbItems, savedLabel, captureLabel, setSavedLabel };
}
